(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["promo-visibility"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const modalSelector = '.ecomsend__Modal__Container';
    const dismissedModals = new WeakSet();

    const suppressPromotions = () =>
      root.dataset.pageType === 'product' ||
      root.dataset.pageType === 'cart' ||
      root.classList.contains('cart-drawer-open');

    const dismissPromotions = () => {
      if (!suppressPromotions()) return;

      document.querySelectorAll(modalSelector).forEach((modal) => {
        const closeButton = modal.querySelector('.ecomsend__Modal__CloseButton');
        if (!closeButton || dismissedModals.has(modal)) return;

        // Let the app remove its focus trap and any scroll lock itself.
        dismissedModals.add(modal);
        closeButton.click();
      });
    };

    const observePromotions = () => {
      dismissPromotions();

      new MutationObserver((mutations) => {
        if (!suppressPromotions()) return;

        const hasNewContent = mutations.some((mutation) => mutation.addedNodes.length > 0);
        if (hasNewContent) dismissPromotions();
      }).observe(document.body, { childList: true, subtree: true });

      new MutationObserver(dismissPromotions).observe(root, {
        attributes: true,
        attributeFilter: ['class'],
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observePromotions, { once: true });
    } else {
      observePromotions();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
